import React, { useState, useEffect, useRef } from 'react';
import '../../css/huerto/scoring.css';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import Loading from '../../bronson/Loading';
import Globals from '../../../Globals';
import '../../css/huerto/scoringTable.css';
import ContractsService from '../../../services/ContractsService';
import Input from '../../bronson/Input';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
} from '@mui/material';

const ConcesionarioAcceso = props => {
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [loaded, setloaded] = useState(true);
    const [
        metricaAccesoConcesionarios,
        setmetricaAccesoConcesionarios,
    ] = useState(getMetricaAccesoConcesionarios);
    const [
        metricaAccesoConcesionariosBase,
        setmetricaAccesoConcesionariosBase,
    ] = useState([]);
    const [filter, setFilter] = useState([]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = event => {
        setrowsPerPage(+event.target.value);
        setPage(0);
    };
    useEffect(() => {
        var actualState = metricaAccesoConcesionariosBase;
        filter.forEach(filt => {
            var newState = [];
            var filterstr = filt[1];
            if (filt[0] === 'Perfil') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.USCDESCPERFIL.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'Cliente') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.CACNOMBRE.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'fechHastaAño') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr >= element.AÑO) newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'fechDesdeAño') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr <= element.AÑO) newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'fechHastaMes') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr >= element.MES) newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'fechDesdeMes') {
                if (filterstr != '')
                    actualState.forEach(element => {
                        if (filterstr <= element.MES) newState.push(element);
                    });
                else newState = actualState;
            }
            actualState = newState;
        });
        setmetricaAccesoConcesionarios(actualState);
    }, [filter]);

    async function getMetricaAccesoConcesionarios() {
        var _dataSimulacionAccesoConcesionarios = await new ContractsService().getMetricaAccesoConcesionarios(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _dataSimulacionAccesoConcesionarios &&
            _dataSimulacionAccesoConcesionarios.statusCode === 200 &&
            _dataSimulacionAccesoConcesionarios.body &&
            _dataSimulacionAccesoConcesionarios.body.Result
        ) {
            var dataSimulacionAccesoConcesionarios = JSON.parse(
                _dataSimulacionAccesoConcesionarios.body.Result
            );
            var consultas = 0;
            dataSimulacionAccesoConcesionarios.forEach(element => {
                consultas += element.NUMCONSULTA;
            });
            setmetricaAccesoConcesionarios(dataSimulacionAccesoConcesionarios);
            setmetricaAccesoConcesionariosBase(
                dataSimulacionAccesoConcesionarios
            );
            setloaded(false);
        }
    }
    const onChangeFilter = target => {
        var _filter = [];
        var update = false;
        filter.forEach(element => {
            if (element[0] === target.target.id) {
                update = true;
                _filter.push([target.target.id, target.target.value]);
            } else _filter.push(element);
        });
        if (!update) _filter.push([target.target.id, target.target.value]);

        setFilter(_filter);
    };

    var rows = [];
    if (metricaAccesoConcesionarios.length > 0) {
        try {
            metricaAccesoConcesionarios
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(row =>
                    rows.push(
                        <TableRow
                            id={row.CACNOMBRE + rows.length}
                            key={row.CACNOMBRE + rows.length}
                            style={{
                                height: '48px',
                                marginTop: '5px',
                                marginBottom: '5px',
                            }}
                            className="iconHover"
                        >
                            <TableCell>{row.AÑO}</TableCell>
                            <TableCell>{row.MES}</TableCell>
                            <TableCell>{row.USCDESCPERFIL}</TableCell>
                            <TableCell>{row.CACNOMBRE}</TableCell>
                            <TableCell>{row.CODECONSE}</TableCell>
                            <TableCell>{row.USR}</TableCell>
                            <TableCell>{row.NUMCONSULTA}</TableCell>
                        </TableRow>
                    )
                );
        } catch {
            return <div></div>;
        }
    }

    return (
        <React.Fragment>
            <Loading ariaBusy={loaded}></Loading>
            <div className="u-pb-small u-rema-full-height">
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    <div className="o-component-wrapper u-hide@s">
                        <span
                            className="back-to-matrix u-float-left"
                            onClick={() =>
                                props.setviewconcesionarioAcceseo(false)
                            }
                        >
                            <i className="c-icon c-icon--[semantic-back] c-icon--small" />
                            <label className="iconHover">
                                Volver a metricas
                            </label>
                        </span>
                        <h3 className="u-text-center">
                            <div
                                className="iconHover"
                                style={{ display: 'contents' }}
                                onClick={() =>
                                    props.setviewconcesionarioAcceseo(false)
                                }
                            >
                                Metricas Acceso por Perfiles
                            </div>
                        </h3>
                    </div>

                    <section className="o-layout__item u-1/4">
                        <h4
                            className="u-text-center"
                            style={{ paddingTop: '25px' }}
                        >
                            Filtros
                        </h4>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Concesionario
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Cliente',
                                        type: 'text',
                                        placeHolder: 'Introduce un Cliente',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>

                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Perfil
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Perfil',
                                        type: 'text',
                                        placeHolder: 'Introduce un Perfil',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Fecha desde
                            </button>
                        </h3>
                        <div
                            className="c-accordion__content c-accordion__content--max-width"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechDesdeAño',
                                        type: 'number',
                                        placeHolder: 'Año',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechDesdeMes',
                                        type: 'number',
                                        placeHolder: 'Mes',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Fecha hasta
                            </button>
                        </h3>
                        <div
                            className="c-accordion__content c-accordion__content--max-width"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechHastaAño',
                                        type: 'number',
                                        placeHolder: 'Año',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechHastaMes',
                                        type: 'number',
                                        placeHolder: 'Mes',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>

                        <button
                            className="c-btn o-layout__item u-1/1"
                            style={{ marginTop: '20px' }}
                            onClick={() =>
                                props.tableCreate(
                                    metricaAccesoConcesionarios,
                                    'metricaAccesoConcesionarios'
                                )
                            }
                        >
                            descargar metrica - Acceso por Perfiles
                        </button>
                    </section>

                    <section className="o-layout__item u-3/4">
                        <Table id="tablaAccesoConcesionario">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            minWidth: '50px',
                                            maxWidth: '50px',
                                        }}
                                    >
                                        Año
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '50px',
                                            maxWidth: '50px',
                                        }}
                                    >
                                        Mes
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Perfil
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '150px',
                                            maxWidth: '150px',
                                        }}
                                    >
                                        Concesionario
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Codigo.Conce
                                    </TableCell>{' '}
                                    <TableCell
                                        style={{
                                            minWidth: '200px',
                                            maxWidth: '200px',
                                        }}
                                    >
                                        Usuario Log
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '80px',
                                            maxWidth: '80px',
                                        }}
                                    >
                                        Cantidad de Accesos
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>{rows}</TableBody>
                        </Table>
                        {metricaAccesoConcesionarios.length > 10 && (
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, 100, 1000]}
                                component="div"
                                count={metricaAccesoConcesionarios.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        )}
                    </section>
                </section>
            </div>
        </React.Fragment>
    );
};

export default withCookies(withRouter(ConcesionarioAcceso));
